export default __webpack_public_path__ + "static/media/unit_type_blue_icon.fa1b5de0.svg";